import React from 'react'

const RacingBall = ({ i, addBall }) => {

    const colors = [
        {
            id:0,
            color:'#ffe600'
        },
        {
            id:1,
            color:'#0077ff'
        },
        {
            id:2,
            color:'#181818'
        },
        {
            id:3,
            color:'#ff9100'
        },
        {
            id:4,
            color:'#00e1ff'
        },
        {
            id:5,
            color:'#161152'
        },
        {
            id:6,
            color:'#525252'
        },
        {
            id:7,
            color:'#ff4e74'
        },
        {
            id:8,
            color:'#970000'
        },
        {
            id:9,
            color:'#004b25'
        }
    ]

    const color = colors.find((color) => color.id === i)

  return (
    <div onClick={() =>addBall(i + 1)} className='cursor-pointer racingballContainer flex flex-col justify-center items-center space-y-1 w-auto'>
        <div style={{ '--i':`${color.color}` }} className={` racingball flex justify-center items-center rounded-full w-[35px] h-[35px]`}>
            <p className='z-[1] font-semibold'>{ i + 1 }</p>
        </div> 
        <p className='font-semibold'>9</p>   
    </div>
  )
}

export default RacingBall